import React from 'react';
import ContactContainer from './contactUsComponent/contact-container';
import HeroBanner from './contactUsComponent/hero-banner';
import usePageTitle from '../usePageTitle';

export default function ContactUs() {
    usePageTitle({
        title: 'TaxObey | Contact Us',
        description: 'Contact TaxObey for tax compliance, accounting support, and advisory assistance. Reach us by phone or email to discuss your needs.',
        path: '/contact',
    });

    return (
        <>
            <HeroBanner />
            <ContactContainer />
        </>
    );
}